import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const UserDetailContainer = styled.div`
	display: block;
	overflow: auto;
	margin-top: var(--margin-3);
	background-color: var(--white);
	border-radius: var(--small-border-radius);
	padding: 0 var(--padding-2);
`;

export const TitleRow = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	width: 100%;
	${(props) => props.justifyContent && `justify-content: ${props.justifyContent};`}
	border-bottom: 1px solid var(--border-color);
	padding: var(--padding-2) 0;
	margin-bottom: var(--margin-2);

	.title {
		width: 100%;
	}
`;

export const UserDetails = styled.div`
	display: block;
	width: 100%;
	padding: 0;
	display: flex;
	flex-wrap: wrap;

	@media ${Breakpoints.mobile} {
		padding: var(--padding-2) var(--padding-3);
	}
`;

export const Row = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;
